// @flow

// Client-side title validation mirrors the server exactly (trim, then 3–128 chars,
// reject control characters). Exported for reviewability.
export const validateThreadTitle = (raw: string): string | null => {
  const trimmed = String(raw || '').trim();
  if (trimmed.length < 3) return 'Title must be at least 3 characters';
  if (trimmed.length > 128) return 'Title must be 128 characters or fewer';
  // eslint-disable-next-line no-control-regex
  if (/[\u0000-\u001F\u007F]/.test(trimmed)) return 'Title contains invalid characters';
  return null;
};
